import styled from '@emotion/styled'
import tw from 'twin.macro'

const StyledArticle = styled.div`
  width: 1200px;
  ${tw`mx-auto py-6`}
`
const StyledArticleList = styled.div`
  width: ${({ isShowSide }) => {
    return isShowSide ? '851px' : '100%'
  }};
  .article-list-item {
    border-radius: 8px;
    padding: ${({ isSimpleList }) => {
      return isSimpleList ? '0' : '16px'
    }};
    .article-list-item-left {
      display: ${({ isSimpleList }) => {
        return isSimpleList ? 'flex' : 'block'
      }};
      gap: ${({ isSimpleList }) => {
        return isSimpleList ? '50px' : '0'
      }};
      justify-content: space-between;
      align-items: center;
      .article-tag {
        white-space: nowrap;
        margin-right: 12px;
        font-size: 14px;
        border-radius: 4px;
        padding: 2px 9px;
      }
      .article-title {
        height: auto !important;
        opacity: 0.85;
        font-weight: ${({ isSimpleList }) => {
          return isSimpleList ? '400' : '500'
        }};
        margin: 0;
        line-height: 26px;
        overflow: hidden !important;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: ${({ tagSlug }) => {
          return tagSlug ? 1 : 2
        }};
        -webkit-box-orient: vertical;
      }
      .article-content {
        height: auto !important;
        font-size: var(--font-size-sm);
        line-height: 22px;
        overflow: hidden !important;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-bottom: 8px;
      }
      .article-main {
        font-size: var(--font-size-md);
        color: var(--ow-color-gray-100);
      }
      .article-block-image-body {
        margin-bottom: 24px;
        .img-content {
          height: auto !important;
          > div + div {
            margin-left: 8px;
          }
          img {
            width: 195px !important;
            height: 146px !important;
            object-fit: cover;
            border-radius: 4px;
          }
          ${tw`flex`}
        }
        ${tw`flex`}
      }
      .article-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        ${tw`mr-2`}
      }
      .article-author {
        height: auto !important;
        margin-right: 8px;
        font-size: var(--font-size-sm);
        color: #94a7ba;
        line-height: 22px;
      }
      .bottom-info {
        > div {
          .number {
            font-weight: var(--font-weight-bolder);
            font-size: var(--font-size-sm);
            line-height: 22px;
            max-width: 200px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            ${tw`mr-1`}
          }
          .text {
            font-size: var(--font-size-sm);
            line-height: 22px;
            white-space: nowrap;
          }
          ${tw`mr-6`}
        }
        .forward-text {
          font-size: var(--font-size-sm);
          line-height: 22px;
          white-space: nowrap;
        }
        ${tw`flex items-center flex-wrap`}
      }
    }
    .article-list-item-right {
      .img-content {
        height: auto !important;
        img {
          width: 200px;
          height: 150px !important;
          object-fit: cover;
          border-radius: 4px;
        }
      }
    }
  }
  .article-list-item + .article-list-item {
    border-top: ${({ showSplit }) => {
      return showSplit ? '1px solid var(--ow-color-neutral-300)' : 'none'
    }};
    margin-top: ${({ isSimpleList }) => {
      return isSimpleList ? '22px' : '0'
    }};
  }
`

const StyledOtherArticle = styled.div`
  min-width: 325px;
  max-width: 325px;
  background: #f3f5f8;
  border-radius: 4px;
  padding-top: 23px;
  .other-article-header {
    padding: 0 23px;
    .other-article-title {
      font-weight: var(--font-weight-bold);
      font-size: 18px;
      color: var(--text-gray-100);
    }
    .refresh {
      font-size: var(--font-size-sm);
      color: var(--text-gray-200);
    }
    ${tw`flex items-center justify-between`}
  }
`
const StyledOtherArticleList = styled.div`
  .other-article-list-item {
    padding: 17px 23px;
    cursor: pointer;
    .article-title {
      height: auto !important;
      font-size: var(--font-size-sm);
      color: rgba(0, 0, 0, 0.9);
      line-height: 22px;
      color: var(--ow-color-gray-100);
      line-height: 22px;
      overflow: hidden !important;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 8px;
    }
    .article-author {
      height: auto !important;
      font-size: var(--font-size-sm);
      color: #94a7ba;
      line-height: 22px;
      margin-right: 9.15px;
    }
    .bottom-info {
      > div {
        .number {
          font-weight: var(--font-weight-bolder);
          font-size: var(--font-size-xs);
          color: #758697;
          line-height: 22px;
          ${tw`mr-1`}
        }
        .text {
          font-size: var(--font-size-xs);
          color: #758697;
          line-height: 22px;
        }
      }
      .forward-text {
        font-size: var(--font-size-sm);
        color: #95a8b9;
        line-height: 22px;
      }
      > div + div {
        ${tw`ml-6`}
      }
      ${tw`flex items-center -ml-2`}
    }
    &:hover {
      .article-title {
        color: var(--ow-color-primary-700);
      }
    }
  }
  .other-article-list-item + .other-article-list-item {
    border-top: 1px solid var(--ow-color-neutral-300);
  }
`

export {
  StyledArticle,
  StyledArticleList,
  StyledOtherArticle,
  StyledOtherArticleList,
}
